import { createFileRoute } from "@tanstack/react-router"

import { DesktopAccounts } from "@/crm/components/accounts/desktop/accounts-table"
import { MobileAccounts } from "@/crm/components/accounts/mobile/accounts-list"
import { Adaptive } from "@/crm/lib/viewport"

export const Route = createFileRoute("/_crm/accounts")({
  component: AccountsRoute,
})

function AccountsRoute() {
  return <Adaptive desktop={<DesktopAccounts />} mobile={<MobileAccounts />} />
}
